export default __webpack_public_path__ + "static/media/7.12ef2f66.pdf";